import { ControlledFormSlice, OrganismFormStepperEvents } from 'wolf/components/organisms/o-form-stepper/o-form-stepper.events';
import controller from 'wolf/global/js/controller';
import ControllerBase from '../../../../global/js/ControllerBase';
import { MoleculeFormStepResumeSliceProps } from '../m-formstep-resume-slice/m-formstep-resume-slice.data';
const resumeSliceMolecule = require('components/molecules/m-formstep-resume-slice/m-formstep-resume-slice.template.twig') as any;

type ComponentRefs = {
    resumeContainer: 'step-resumes-container';
};

export enum ResumeStepEvents {
    REQUEST_RESUMES_SLICE_SUMMARY = 'REQUEST_RESUMES_SLICE_SUMMARY',
    RECEIVE_RESUMES_SLICE_SUMMARY = 'RECEIVE_RESUMES_SLICE_SUMMARY'
}

export default class ControllerFormstepResumeStep extends ControllerBase<ComponentRefs> {
    resumeContainer: HTMLDivElement
    stepResumes: MoleculeFormStepResumeSliceProps[]
    formSlice: Record<string, string | boolean> = {}

    private static readonly componentRefs: ComponentRefs = {
        resumeContainer: 'step-resumes-container',
    };

    constructor(element: HTMLElement) {
        super(element, [], Object.values(ControllerFormstepResumeStep.componentRefs));
        this.resumeContainer = this.$references[ControllerFormstepResumeStep.componentRefs.resumeContainer]
        this.initComponent()
        this.observeTermsAndConditionsCheckbox()
    }

    observeTermsAndConditionsCheckbox(): void {
        const checkboxes = this.$element.getElementsByTagName('input');

        Array.from(checkboxes).forEach(element => {
            element.addEventListener('change', (e: Event) => {
                const currentCheckbox = e.target as HTMLInputElement
                const currentCheckboxName = currentCheckbox.name as string
                this.formSlice[currentCheckboxName] = currentCheckbox.checked
                this.sendControlledFormToParentStepper()
            })
        });
    }

    registerEvents(): void {
        window.addEventListener(ResumeStepEvents.RECEIVE_RESUMES_SLICE_SUMMARY, (event: CustomEvent<{ stepResumes: MoleculeFormStepResumeSliceProps[][] }>) => {
            this.stepResumes = event.detail.stepResumes.flat()
            if (this.stepResumes.length) {
                this.resumeContainer.innerHTML = ''
                const nodesArray: string[] = []
                this.stepResumes.forEach(data => nodesArray.push(resumeSliceMolecule({ data })))
                nodesArray.forEach(twigString => {
                    const sliceElement = this.domUtils.appendRawHtmlToDomElement(this.resumeContainer, twigString, 'beforeend')
                    new controller.ControllerFormStepResumeSlice(sliceElement as HTMLElement)
                })
            }
        })
    }

    sendControlledFormToParentStepper(): void {
        this.dispatchCustomEvent(OrganismFormStepperEvents.RECEIVE_CONTROLLED_FORM_SLICE, {
			stepId: 'termsAndConditions', // this is in the final payload object
			formSlice: this.formSlice
		}, false, true)
    }

    initComponent(): void {
        this.registerEvents()
    }

}
